<template>
  <PageHeader :title="title" />
  
  <tablecustom 
    @search="searchB" 
    :dataParams="dataParams"
    :objParams="objParams"
    :columns="columns" 
    :rows="rows" 
    @getdata="getdata"
    @changelimit="changelimit"
    @changeFilter="changeFilter" 
    @clearFilter="clearFilter"
    :pages="objPages"
    :showpag="true"
  />

</template>

<script>
import PageHeader from "@/components/page-header";
import infoblocks from '@/components/info/blocks'
import tablecustom from '@/components/globaltable/index';
import { Archive } from '@/API.js';
import { storeS } from "@/store";

let apiArchive = new Archive();

export default {
  components: {
    PageHeader,
    tablecustom,
    infoblocks
  },
  data() {
    return {
      title: "archiveShift",
      dataParams: {
          status: false,
          page: "calls"
      },
      objParams:{
          page: '1',
          pagelimit: '10',
          search: '',
          // status: '',
          // priority: '',
          // workerId: '',
          pr1: '',
          pr2: ''
      },
      columns: [
        {
          name: this.$t("Employee"),
          text: "workerName",
          align: "right",
          status: true
        },
        {
          name: this.$t("openShift"),
          text: 'openDatetime',
          align: "left",
          status: true
        },
        {
          name: this.$t("closeShift"),
          text: "closeDatetime",
          align: "right",
          status: true
        },
      ],
      rows: [],
    };
  },
  created() {
    this.getdata();
  },
  methods: {
    getdata(page){
      this.objParams.page = page != undefined ? page : '1';
      apiArchive.getAllArchiveShifts(this.objParams).then(result => {
        if(result.status == 'done'){
          this.rows = result.data.items;
          this.objPages = result.data
        }
      })
    },
    changelimit: function(limit){
        this.objParams.pagelimit = limit;
        this.getdata();
    },
    searchB(e){
      this.objParams.search = e
      this.getdata();
    },
    changeFilter(name, value){
      if(!name.type && value != undefined){
        if(name == 'pr'){
          this.objParams['pr1'] = value[0];
          this.objParams['pr2'] = value[1];
        } else {
          this.objParams[name] = value;
        }
        this.getdata();
      }
    },
  },
  computed: {
    user() {
      return storeS.userbase
    },
    perms() {
      return storeS.perms
    },
    check() {
      return storeS.checks
    },
  },
};
</script>

<style scoped>
  .tr_etner:hover {
  cursor: pointer;
  background: #f3f3f9;
  }
  .howto_block {
  margin-left:10px;
  }
  .howto_block i {
  font-size: 23px;
  opacity: 0.5;
  }
  .howto_block i:hover{
  opacity: 1;
  }

  .howto_block {
  position: relative;
  display: inline-block;
  }

  .howto_block .tooltiptext {
  visibility: hidden;
  position: absolute;
  width: 120px;
  background-color: #555;
  color: #fff;
  text-align: center;
  padding: 10px 0;
  border-radius: 6px;
  z-index: 1;
  opacity: 0;
  transition: opacity 0.3s;
  margin-left: 10px;
  }

  .howto_block .tooltiptext::after {
  content: "";
  position: absolute;
  top: 50%;
  right: 100%;
  margin-top: -7px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent #555 transparent transparent;
  }

  .howto_block:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
  }
</style>
